<h1 mat-dialog-title>History Image</h1>
<div mat-dialog-content>
  <img [src]="data.url" class="dimg"/>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
